import React, {Component} from 'react';

class IconMotion extends Component {
  render() {
    const {color, size} = this.props;
    const h = size === "lg"
      ? 128
      : 48;
    const w = size === "lg"
      ? 128
      : 48;
    return (
      <i className="emoji">
        <svg style={{fill: color}} className="emoji" viewBox="-8 -8 64 64" height={h} width={w}  xmlns="http://www.w3.org/2000/svg">
          <path d="M26.9,0c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.7,0.2,1C28,3.3,29,5.5,29,8c0,1.2-0.3,2.3-0.7,3.4L28,12.3l0.8,0.4
        c0.3,0.1,0.5,0.3,0.8,0.4c2.2,1.4,3.4,3.5,3.4,5.6V30c0,2.4-1.4,4.4-3.4,5.4L29,35.7V45c0,1.3-0.4,2.5-1.1,3.4
        c-0.3,0.5-0.2,1.1,0.3,1.4s1.1,0.2,1.4-0.3c0.9-1.3,1.4-2.9,1.4-4.6v-8.2c2.4-1.4,4-3.9,4-6.8V18.8c0-2.9-1.7-5.6-4.3-7.3
        c-0.1-0.1-0.2-0.1-0.3-0.2c0.3-1,0.7-2.1,0.7-3.3c0-3-1.2-5.7-3.2-7.7C27.6,0.1,27.3-0.1,26.9,0z M33.1,0c-0.3,0.1-0.6,0.3-0.7,0.6
        c-0.1,0.3-0.1,0.6,0,0.9c1,2,1.6,4.2,1.6,6.5c0,0.5,0,1.1-0.1,1.6l-0.1,0.5l0.4,0.3c2.4,2.3,3.8,5.2,3.8,8.3V30
        c0,3.3-1.4,6.2-3.7,8.2L34,38.5V45c0,1.3-0.2,2.5-0.7,3.7c-0.2,0.5,0.1,1.1,0.6,1.3s1.1-0.1,1.3-0.6C35.7,48,36,46.5,36,45v-5.7
        c2.4-2.4,4-5.7,4-9.3V18.8c0-3.5-1.5-6.8-4.1-9.4C35.9,8.9,36,8.5,36,8c0-2.7-0.7-5.2-1.9-7.5C33.9,0.1,33.5-0.1,33.1,0z M20,2
        c-3.3,0-6,2.7-6,6s2.7,6,6,6c-4,0-6.4,0.7-7.9,1.7c-1.5,1-2.1,2.2-2.1,3.1V30c0,1.6,1.4,3,3,3h1v12c0,1.6,1.4,3,3,3h6
        c1.6,0,3-1.4,3-3V33h1c1.6,0,3-1.4,3-3V18.8c0-0.9-0.5-2.1-2-3.1S24,14,20,14c3.3,0,6-2.7,6-6C26,4.7,23.3,2,20,2z M20,4
        c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S17.8,4,20,4z M20,16c3.8,0,5.8,0.7,6.8,1.3s1.1,1.3,1.1,1.4V30c0,0.6-0.4,1-1,1h-3v14
        c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1V31h-3c-0.6,0-1-0.4-1-1V18.8c0,0,0.1-0.7,1.2-1.4S16.3,16,20,16z"/>
        </svg>
      </i>
    )
  }
};

export default IconMotion;



// WEBPACK FOOTER //
// ./src/style/icon/IconMotion.js